import { PermissionType } from '../../core/models/permission';

export class MenuGroupDef {
  label: string;

  subGroup?: MenuGroupDef[];

  menuItem?: string;

  subMenuItem?: string;

  subNav?: string;

  permission?: PermissionType;
}

export const MANAGE_SIDENAV_DEFINITION: MenuGroupDef[] = [
  {
    label: 'Players',
    permission: PermissionType.PLAYERS,
    subGroup: [
      { label: 'All players', menuItem: 'players' },
      { label: 'Alerts', menuItem: 'alerts' },
      { label: 'Triggers Snoozes', menuItem: 'triggers-snoozes' },
      { label: 'Starred', menuItem: 'playerstarred' },
      // { label: 'Sessions', menuItem: 'currentsessionticker' },
      { label: 'Documents', menuItem: 'documents' },
      { label: 'Linked accounts', menuItem: 'linkedaccounts' },
      { label: 'Timers', menuItem: 'timers' },
      { label: 'Tags', menuItem: 'player_tags' },
      { label: 'Commentary', menuItem: 'player_commentary' },
      {
        label: 'Diagnostics',
        subNav: 'players-diagnostics',
      },
    ],
  },
  {
    label: 'Payments',
    permission: PermissionType.MANAGEMENT_PAYMENTS,
    subGroup: [
      {
        label: 'Deposits',
        subNav: 'deposits',
      },
      { label: 'Withdrawals', subNav: 'withdrawals' },
    ],
  },
  {
    label: 'Gaming',
    subGroup: [
      {
        label: 'Casino',
        permission: PermissionType.CASINO,
        subGroup: [
          { label: 'Configs', menuItem: 'games' },
          { label: 'Curation', menuItem: 'casino-dashboard' },
          {
            label: 'Metadata',
            subNav: 'metadata',
          },
          {
            label: 'Scheduling',
            subNav: 'scheduling',
          },
          { label: 'Lines', menuItem: 'game_lines' },
          { label: 'Widgets', menuItem: 'widgets' },
        ],
      },
      {
        label: 'Jackpots',
        permission: PermissionType.CASINO, //todo
        subGroup: [
          { label: 'Availability', menuItem: 'jackpots/availability' },
          { label: 'Contributions', menuItem: 'jackpots/contributions' },
          { label: 'Winners', menuItem: 'jackpots/winners' },
        ],
      },
      {
        label: 'Lottos',
        permission: PermissionType.LOTTO,
        subGroup: [
          { label: 'Lottos', menuItem: 'lottos/lottos' },
          { label: 'Draws', menuItem: 'lottos/draws' },
          { label: 'Tickets', menuItem: 'lottos/tickets' },
        ],
      },
      {
        label: 'Lottos (Deprecated)',
        permission: PermissionType.LOTTO,
        subGroup: [
          { label: 'Configs', menuItem: 'lotto' },
          { label: 'Curation', menuItem: 'draws-dashboard' },
          { label: 'Draws', menuItem: 'draws' },
          { label: 'Grading', menuItem: 'gradinglinesticker' },
          {
            label: 'Diagnostics',
            subNav: 'lotto-diagnostics',
          },
        ],
      },
      {
        label: 'Scratch',
        permission: PermissionType.SCRATCH,
        subGroup: [
          { label: 'Configs', menuItem: 'scratch-configs' },
          { label: 'Curation', menuItem: 'scratch-dashboard' },
        ],
      },
      {
        label: 'Bundles',
        permission: PermissionType.BUNDLES,
        subGroup: [
          { label: 'Configs', menuItem: 'Bundles' },
          { label: 'Curation', menuItem: 'bundle-ordering' },
        ],
      },
    ],
  },
  {
    label: 'Offers',
    permission: PermissionType.OFFERS,
    subGroup: [
      { label: 'Promotions', menuItem: 'promotions-v2' },
      { label: 'Promotion mappings', menuItem: 'promotion-mappings' },
      { label: 'Probability rewards', menuItem: 'probability-rewards' },
      { label: 'Bundles v2', menuItem: 'bundles-v2' },
      { label: 'Test Users', menuItem: 'test-users' },
      { label: 'Mini game campaigns', menuItem: 'mini-games-campaigns' },
      { label: 'Playthrough profiles', menuItem: 'wagering-profiles' },
      {
        label: 'Free spins',
        subNav: 'free-spins',
      },
      {
        label: 'Bonuses',
        subNav: 'bonuses',
      },
      { label: 'Rule book', menuItem: 'rule-book' },
      { label: 'Promotions (Deprecated)', menuItem: 'promotions' },
      { label: 'Campaigns (Deprecated)', menuItem: 'campaign' },
    ],
  },
  {
    label: 'Content',
    subGroup: [
      {
        label: 'App',
        permission: PermissionType.APP,
        subGroup: [
          {
            label: 'Hero Slides',
            subNav: 'hero-slides',
          },
          {
            label: 'Deep links',
            subNav: 'deep-links',
          },
          { label: 'Learn pages', subNav: 'learn-pages' },
          { label: 'Batch article update', menuItem: 'zendesk' },
          { label: 'Support', menuItem: 'sys-config', subMenuItem: 'support' },
          { label: 'Terms', menuItem: 'termsandconditions' },
          { label: 'Lobby', menuItem: 'lobby' },
        ],
      },
      {
        label: 'Email',
        permission: PermissionType.EMAIL,
        subGroup: [{ label: 'Templates', menuItem: 'fasttrack' }],
      },
      {
        label: 'Website',
        permission: PermissionType.WEBSITE,
        subGroup: [
          { label: 'Sites', menuItem: 'web-site' },
          { label: 'Assets', menuItem: 'web-page' },
          {
            label: 'Root',
            subNav: 'root',
          },
          { label: 'Templates', menuItem: 'templatemacro' },
        ],
      },
    ],
  },
];

export const SETTINGS_SIDENAV_DEFINITION: MenuGroupDef[] = [
  {
    label: 'Team',
    permission: PermissionType.TEAM,
    subGroup: [
      { label: 'Roles', menuItem: 'roles' },
      { label: 'Users', menuItem: 'admin-user' },
      { label: 'Audit', menuItem: 'audit' },
    ],
  },
  {
    label: 'Payments',
    permission: PermissionType.SETTINGS_PAYMENTS,
    subGroup: [
      { label: 'Types', menuItem: 'PaymentTypeDefinitions' },
      { label: 'Solutions', subNav: 'solutions' },
      { label: 'Gateways', subNav: 'gateways' },
      { label: 'Deposits', subNav: 'payments-deposits' },
      { label: 'Withdrawals', menuItem: 'auto-withdrawals-config' },
      { label: 'Profiles', menuItem: 'PaymentProfiles' },
      { label: 'Exemptions', menuItem: 'exemptions-config' },
    ],
  },
  {
    label: 'Gaming',
    permission: PermissionType.GAMING,
    subGroup: [
      { label: 'Providers', menuItem: 'provider-availability' },
      { label: 'Studios', menuItem: 'studio-availability' },
    ],
  },
  {
    label: 'Compliance',
    permission: PermissionType.COMPLIANCE,
    subGroup: [
      { label: 'Safer gambling', menuItem: 'sys-config', subMenuItem: 'responsible-gaming' },
      { label: 'Player duplicates', menuItem: 'sys-config', subMenuItem: 'player-dups' },
      { label: 'System reality check profiles', menuItem: 'rgprofiles' },
      { label: 'Verification profiles', menuItem: 'VerificationProfiles' },
    ],
  },
  {
    label: 'Diamonds',
    permission: PermissionType.DIAMONDS,
    subGroup: [
      { label: 'Status tires', menuItem: 'diamond-tiers' },
      { label: 'Groups', menuItem: 'diamondgroup' },
    ],
  },
  {
    label: 'Locale',
    permission: PermissionType.LOCALE,
    subGroup: [
      { label: 'Access rights', menuItem: 'AccessProfiles' },
      {
        label: 'Addresses',
        subNav: 'addresses',
      },
      { label: 'Countries', menuItem: 'country-cass' },
      { label: 'Currencies', subNav: 'currencies' },
    ],
  },
  {
    label: 'System',
    permission: PermissionType.SYSTEM,
    subGroup: [
      { label: 'Bonus', menuItem: 'sys-config', subMenuItem: 'bonus-config' },
      { label: 'Quick Filters', menuItem: 'quick-filters' },
      { label: 'Sessions', menuItem: 'sys-config', subMenuItem: 'player-session' },
      { label: 'Feature flags', menuItem: 'sys-config', subMenuItem: 'enable-functionality' },
      { label: 'Geo exceptions', menuItem: 'sys-config', subMenuItem: 'geo-fence' },
      { label: 'Push notifications', menuItem: 'sys-config', subMenuItem: 'push-notification' },
      { label: 'SMS', menuItem: 'sys-config', subMenuItem: 'sms' },
      { label: 'App alerts', menuItem: 'sys-config', subMenuItem: 'app-alerts' },
      { label: 'Defaults', menuItem: 'sys-config', subMenuItem: 'overall' },
      { label: 'Variables', menuItem: 'dynamic_options' },
    ],
  },
  {
    label: 'Diagnostics',
    permission: PermissionType.DIAGNOSTICS,
    subGroup: [
      { label: 'App errors', menuItem: 'report-app-error' },
      { label: 'System audit', menuItem: 'report-audit' },
    ],
  },
];
